import React from 'react'
import { Tooltip, Icon } from 'components'

export default ({ icon, tooltip, ...props }) => (
  <Tooltip text={tooltip} extraHeight={50} clickable {...props}>
    <Icon icon={icon} fill="lockedWhite" margin="0 12px" />
  </Tooltip>
)
